import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { AlertService } from '../alert.service';
import { Alert } from '../alert';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [MatSnackBarModule, MatDialogModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  constructor(
    private alertService: AlertService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.alertService.getError().subscribe((error) => {
      this.handleError(error);
    });
    this.alertService.getSuccess().subscribe((error) => {
      this.handleError(error);
    });
  }

  handleError(error: Alert) {
    if (error) {
      switch (error.type) {
        case 'snackbar': {
          const config = new MatSnackBarConfig();
          config.duration = 3000;
          this.snackBar.open(error.message, '', config);
          break;
        }
        case 'alert':
          alert(error.message);
          break;
        case 'dialog': {
          const dialogRef: MatDialogRef<ErrorDialogComponent> = this.dialog.open(ErrorDialogComponent);
          dialogRef.componentInstance.message = error.message;
          break;
        }
      }
    }
  }

  handleSuccess(success: Alert) {
    if (success) {
      switch (success.type) {
        case 'snackbar': {
          const config = new MatSnackBarConfig();
          config.duration = 3000;
          this.snackBar.open(success.message, '', config);
          break;
        }
        case 'alert':
          alert(success.message);
          break;
      }
    }
  }
}
